import React, {forwardRef} from 'react';
import { Row } from 'react-bootstrap';


const Page = forwardRef(({header, children}, ref) => {

    return (
        <React.Fragment>
            <Row>
                <h1 ref={ref}>{header}</h1>
            </Row>
            <Row>
                {children}
            </Row>
        </React.Fragment>);

});

export default Page;